import {Cookie, CookieSetOptions} from "universal-cookie";
import CommonUtil from "./CommonUtil";

export default class CookieUtil {
    static cookie:{ [K in string]?: any; };
    static setCookie:(name: string, value: Cookie, options?: CookieSetOptions) => void;
    static removeCookie: (name: string, options?: (CookieSetOptions | undefined)) => void;

    public static initialize(
        cookie: { [K in string]?: any; },
        setCookie: (name: string, value: Cookie, options?: CookieSetOptions) => void,
        removeCookie: (name: string, options?: (CookieSetOptions | undefined)) => void
    ) {
        this.cookie = cookie;
        this.setCookie = setCookie;
        this.removeCookie = removeCookie;
    }

    public static get(name: string) {
        // const item = sessionStorage.getItem(name);
        if(this.cookie) {
            const item = this.cookie[name];
            try {
                if (item)
                    return item;
                else
                    return item;
            } catch (e) {
                return item;
            }
        }
        else return null;
    }

    public static getExpiresDate(addDates: number) {
        const now = new Date();
        const expiresDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);

        expiresDate.setDate(expiresDate.getDate() + addDates);

        return expiresDate;
    }

    public static set(name: string, value: any, options?: any) {
        if (options == null) {
            options = {} as CookieSetOptions;
        }
        if (options.path == null) {
            options.path = "/";
        }

        this.setCookie(name, value, options);
    }

    public static setCookies(cookie:{ [K in string]?: any; }) {
        this.cookie = cookie;
    }

    public static remove(name: string, options?: (CookieSetOptions | undefined)) {
        this.removeCookie(name, options);
    }
}
